import SearchInput from '../../../../../commons/SearchInput/SearchInput';
import { ReactComponent as SearchIcon } from '../../../../../../assets/vectors/search.svg';
import Button from '../../../../../designSystem/Button/Button';
import { useCommerciaux } from '../../../../../../hooks/fetchers/useCommerciaux/useCommerciaux';
import { ChangeEvent, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { DashboardCommerciauxContext } from '../DashboardCommerciaux.context';
import Empty from '../../../../../commons/Empty/Empty';
import Loading from '../../../../../commons/Loading/Loading';
import DashboardCommerciauxTableRow from './DashboardCommerciauxTableRow/DashboardCommerciauxTableRow';
import Pagination from '../../../../../commons/Pagination/Pagination';
import { ButtonColor } from '../../../../../designSystem/Button/Button.types';
import {
  SearchCommerciauxQuery,
  SearchCommerciauxQueryResponse,
} from './DashboardCommerciauxTable.types';
import { useMutation, useQueryClient } from 'react-query';
import { SEARCH_COM_QUERY_KEY, searchCommerciauxQuery } from './DashboardCommerciauxTable.query';
import { useMergedStatesFromFetchers } from '../../../../../../hooks/useMergedStatesFromFetchers/useMergedStatesFromFetchers';

export default () => {
  const queryClient = useQueryClient();

  const [searchValue, setSearchValue] = useState<string>();
  const [searchResults, setSearchResults] = useState<SearchCommerciauxQueryResponse>();

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage] = useState<number>(25);

  const { setCreateModalOpen, setFiltersModalOpen, filters } = useContext(
    DashboardCommerciauxContext
  );

  const {
    data: commerciaux,
    refetch: refetchCommerciaux,
    isLoading: isCommerciauxLoading,
    error,
  } = useCommerciaux({ page: currentPage, perPage: itemsPerPage, ...filters });

  const { mutate: searchMutate, isLoading: isSearchLoading } = useMutation<
    Awaited<SearchCommerciauxQueryResponse>,
    Error,
    SearchCommerciauxQuery
  >((data) => searchCommerciauxQuery(data), {
    mutationKey: SEARCH_COM_QUERY_KEY,
    onMutate: () => queryClient.cancelMutations(),
    onSuccess: (response) => {
      setSearchResults(response);
    },
    onError: (error) => {
      console.log('error', error);
    },
  });

  useEffect(() => {
    if (searchResults) {
      searchMutate({
        search: searchValue || '',
        params: {
          page: currentPage,
          perPage: itemsPerPage,
          ...filters,
        },
      });
    } else {
      refetchCommerciaux();
    }
  }, [currentPage]);

  useEffect(() => {
    if (searchResults) {
      searchMutate({
        search: searchValue || '',
        params: {
          page: currentPage,
          perPage: itemsPerPage,
          ...filters,
        },
      });
    } else {
      refetchCommerciaux();
    }
  }, [filters]);

  const onChangeSearchText = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      setSearchValue(value);
      setCurrentPage(1);
      if (value.length === 0) {
        setSearchResults(undefined);
      } else {
        searchMutate({
          search: value,
          params: {
            page: currentPage,
            perPage: itemsPerPage,
            ...filters,
          },
        });
      }
    },
    [searchMutate, currentPage, itemsPerPage, filters]
  );

  const numberOfPages = useMemo(() => {
    if (searchResults) {
      // @ts-ignore
      return parseInt(searchResults.total / itemsPerPage) + 1;
    } else {
      // @ts-ignore
      return parseInt(commerciaux?.total / itemsPerPage) + 1;
    }
  }, [commerciaux, itemsPerPage]);

  const { isLoading } = useMergedStatesFromFetchers({
    loadings: [isCommerciauxLoading, isSearchLoading],
  });

  return (
    <>
      <div className="dashboard-commerciaux">
        <div className="dashboard-commerciaux__header">
          <SearchInput
            placeholder="Chercher un commercial..."
            startIcon={SearchIcon}
            onChange={onChangeSearchText}
            handleSelectedSuggestion={(suggestion) => console.log(suggestion)}
          />
          <Button onClick={() => setFiltersModalOpen(true)} color={ButtonColor.Contrast}>
            Filtrer
          </Button>
          <Button onClick={() => setCreateModalOpen(true)}>Ajouter</Button>
        </div>
        {isLoading || error ? (
          error ? (
            <Empty>Aucun commercial pour le moment</Empty>
          ) : (
            <Loading />
          )
        ) : (
          <>
            {searchResults && (
              <table className="dashboard__table dashboard-commerciaux__table">
                <thead>
                  <tr>
                    <th>Prénom</th>
                    <th>Nom</th>
                    <th>Type</th>
                    <th>Adresse email</th>
                    <th>N° de téléphone</th>
                    <th>Actif</th>
                  </tr>
                </thead>
                <tbody>
                  {searchResults?.results.map((commercial, index) => {
                    return <DashboardCommerciauxTableRow key={index} {...{ commercial }} />;
                  })}
                </tbody>
              </table>
            )}
            {!searchResults && commerciaux && commerciaux.results.length > 0 && (
              <table className="dashboard__table dashboard-commerciaux__table">
                <thead>
                  <tr>
                    <th>Prénom</th>
                    <th>Nom</th>
                    <th>Type</th>
                    <th>Adresse email</th>
                    <th>N° de téléphone</th>
                    <th>Actif</th>
                  </tr>
                </thead>
                <tbody>
                  {commerciaux?.results.map((commercial, index) => {
                    return <DashboardCommerciauxTableRow key={index} {...{ commercial }} />;
                  })}
                </tbody>
              </table>
            )}
          </>
        )}
      </div>
      {!isLoading && <Pagination {...{ currentPage, setCurrentPage, numberOfPages }} />}
    </>
  );
};
